import Index from "./home.vue"
let a = Object.assign({Index})
export default a;
